import React from 'react';

const CLASSES = " [ bt-tipo-planilha ] ";

class ButtonTipoTreino extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      id:props.id,
      label:props.label,
      ativo: props.ativo
    }
  }
  render(){
    const {ativo,label,id} = this.state;
    let _classes = CLASSES+(this.props.ativo ? "ativo" : "")
    return(
      <div className="radio pure-u-12-24">
        <div className="">
          <a onClick={this.props.onClick} data-id={id} className={_classes} href="#"><span>{label}</span></a>
       </div>
      </div>
    )
  }
}

export default ButtonTipoTreino;



// WEBPACK FOOTER //
// ./src/classes/planilha-treino/ButtonTipoTreino.js